// Array of path patterns that should be excluded from login redirects
const excludedRoutes = [
  "/login",
  "/workflow/actions/tasks/approvalbyemail/",
  "/workflow/actions-react/electronic-signature",
];

/**
 * Checks if the current path is excluded from login requirements
 * @param {string} pathname - The path to check (defaults to location.pathname)
 * @param {Window} topWindow - The top window to check (defaults to window.top)
 * @returns {boolean} - True if the path is excluded, false otherwise
 */
export function isExcludedRoute(pathname = location.pathname, topWindow = window.top) {
  return excludedRoutes.some(route => 
    pathname === route || 
    pathname.startsWith(route) || 
    topWindow.location.pathname.startsWith(route)
  );
}

export default excludedRoutes;
